export default (variable) => Array.isArray(variable);
